module.exports = __webpack_public_path__ + "media/law_firm_funding/cta-c93cdfe0.jpg";